import TransactionView from '../../components/TransactionView'
import { TransactionType } from '../../../../graphql'
import getColumns from 'views/reports/columns'
import { useFlags } from '@equipmentshare/feature-flags'

export default function PartsOnWorkOrders(): JSX.Element {
	const variables = { transactionTypes: TransactionType.StoreToWorkOrder }
	const flags = useFlags()
	const columns = getColumns( false, flags.enableTswWeightedAverageCost )

	return (
		<TransactionView
			title="Items On Work Orders"
			heaperPageTitle="Parts On Work Orders"
			variables={variables}
			columns={columns}
			storeIdsKey="fromIds"
		/>
	)
}
